import styles from './MyInfo.module.css';

import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Icon from '@mui/material/Icon';
import Typography from '@mui/material/Typography';

import Person from '@mui/icons-material/Person';

import { useState, useEffect } from 'react';

import { getUser, updateUser } from '../../api.js';

import { useAuth } from '../../AuthContext';
import { Patroller } from '../Patroller/Patroller';

export const MyInfo = () => {
    const [ error, setError ] = useState(false);
    const [ loading, setLoading ] = useState(true);
    const [ user, setUser ] = useState(null);

    const { auth, claims, token } = useAuth();

    useEffect(() => {
        const fetchUser = async () => {
            setLoading(true);

            const userData = await getUser(auth.currentUser.uid, token);

            if (userData.error) {
                setError(userData.error);
                setLoading(false);

                return;
            }
            
            setUser(userData);

            setLoading(false);
        };

        fetchUser();
    }, [ auth, token ]);

    const handleOnSave = async (updatedUser) => {
        setLoading(true);
        setError(false);

        const result = await updateUser(updatedUser, token);

        if (result.error) {
            setError(result.error);
            setLoading(false);

            return;
        }

        setError(false);
        setLoading(false);
        setUser(updatedUser);
    };

    if (loading) {
        return <CircularProgress />;
    }

    if (error) {
        return <Alert variant="filled" severity="error">{ error }</Alert>;
    }

    return (
        <div className={ styles.container }>
            <div className={ styles.titleBar }>
                <span>
                    <Icon component={ Person } sx={ { mr: 1 } } />

                    <Typography>My Info</Typography>
                </span>
            </div>

            <div className={ styles.content }>
                <Patroller patroller={ user } userIsAdmin={ claims?.admin } onSave={ handleOnSave } />
            </div>
        </div>
    );
};